export enum ProjectStatus {
  Private = 'PRIVATE',
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
}
